import { Helmet } from 'react-helmet';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
import Navbar from '../../components/light/creative-agency/Navbar';
import Blog from '../../components/light/digital-agency/Blog';
import Footer from '../../components/light/digital-agency/Footer';
import Header from '../../components/light/digital-agency/Header';
import Portfolio from '../../components/light/digital-agency/Portfolio';
import Price from '../../components/light/digital-agency/Price';
import Process from '../../components/light/digital-agency/Process';
import Skills from '../../components/light/digital-agency/Skills';
import Testimonials from '../../components/light/digital-agency/Testimonials';

export default function LHomeDigitalAgency() {
  return (
    <>
      <Helmet>
        <title>SPOB Nigeria – Health · Education · Culture · Environment</title>
        <meta name="description" content="SPOB Nigeria empowers underserved communities across South West Nigeria through health outreach, education, cultural preservation, environmental awareness and youth vocational training." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://spob-nigeria.vercel.app/" />
        <meta property="og:title" content="SPOB Nigeria – Health · Education · Culture · Environment" />
        <meta property="og:description" content="SPOB Nigeria empowers underserved communities across South West Nigeria through health outreach, education, cultural preservation, environmental awareness and youth vocational training." />
        <meta property="og:image" content="https://spob-nigeria.vercel.app/light/assets/imgs/spob/spob-1.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="SPOB Nigeria – Health · Education · Culture · Environment" />
        <meta name="twitter:description" content="SPOB Nigeria empowers underserved communities across South West Nigeria through health outreach, education and youth development." />
        <meta name="twitter:image" content="https://spob-nigeria.vercel.app/light/assets/imgs/spob/spob-1.jpg" />
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg pt-80">
              <Header />
              <Skills />
              <Portfolio />
              <Process />
              <Testimonials />
              <Price />
              <Blog />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
